import axios from '../../../utils/customAxiosUtil';
import {
  ResponseControlGpHistory,
  ResponseControlGroupAuth,
  ControlGpPlanContainsRQ,
  ResponseControlGpWarnLog,
  ControlweatherData,
  ControlGpArcrftWarnRq
} from '../models/controlGpModel';
import qs from 'qs';

export const controlGpApi = {
  getHistory: async (id: string) => {
    if (!id) {
      return null;
    }
    const { data }: ResponseControlGpHistory = await axios.get(
      `api/ctr/cntrl/history/list/${id}`
    );

    return data;
  },
  getWarnLog: async (id: string) => {
    if (!id) {
      return null;
    }

    const { data }: ResponseControlGpWarnLog = await axios.get(
      `api/ctr/cntrl/warn/detail/${id}`
    );

    return data;
  },
  getDetail: async (id: string) => {
    return await axios.get(`api/ctr/cntrl/detail/${id}`);
  },
  getGroupAuth: async (id: number) => {
    if (!id) {
      return null;
    }
    const { data }: ResponseControlGroupAuth = await axios.get(
      `api/ctr/cntrl/group?cstmrSno=${id}`
    );
    return data;
  },
  getFlightPlan: async (idntfNum: string) => {
    if (!idntfNum) {
      return null;
    }

    const { data } = await axios.get(`api/ctr/cntrl/flight_plan/${idntfNum}`);

    return data;
  },
  apiweather: async (rq: ControlweatherData) => {
    const { data } = await axios.get(`api/ctr/cntrl/api/weather`, {
      params: {
        ...rq
      }
    });
    return data;
  },
  checkPlanContains: async (rq: ControlGpPlanContainsRQ) => {
    if (!rq.idntfNum) {
      return null;
    }

    const { data } = await axios.post(`api/ctr/cntrl/contains`, rq);

    return data;
  },
  getArcrftWarnList: async (rq: ControlGpArcrftWarnRq) => {
    if (!rq.cntrlId) return null;
    const { data } = await axios.post(`api/ctr/cntrl/arcrft/warn/list`, rq);

    return data;
  }
  // getArcrftWarnList: async (id: string) => {
  //   if (!id) return null;

  //   const { data } = await axios.get(`api/ctr/cntrl/arcrft/warn/list?id=${id}`);

  //   return data;
  // }
};
